// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + "4be39b2aae2c8be23d08" + ".css";
};